/**
 * For calls whose failure means nothing where they are made, such as a peer that has closed, storage that is full, or
 * text that is not JSON: `attempt` answers undefined where `fn` throws, `quietly` is the handler for a promise whose
 * failure is ignored, `noop` is a callback that does nothing, and `noopAsync` one that resolves having done nothing.
 * Each makes the choice visible where an empty block, or an arrow answering `undefined`, would hide it, which the
 * linter refuses anywhere but here (`scripts/lint/inline-noop.grit`). `packages/runner/src/quietly.ts` is this file,
 * for the daemon, which has none of this package; `packages/runner/test/quietly.test.ts` checks the two agree.
 */
export function attempt<T>(fn: () => T): T | undefined {
  try {
    return fn();
  } catch {
    return undefined;
  }
}

export const quietly = (): undefined => undefined;

export const noop = (): void => undefined;

export const noopAsync = async (): Promise<undefined> => undefined;
